import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IonInput } from '@ionic/angular';
import { ListState, ListType, ListViewMode } from '@usf/ngrx-list';
import { ListTypes } from '../../../shared/constants/lists-constants';
import { UsfProductCardModeEnum } from '../../../shared/constants/usf-product-card-mode.enum';
import {
  EllipsisClickData,
  ProductClickData,
  ProductSelectionData,
} from '../../../shared/models/usf-product-card.model';
import {
  ItemTypes,
  ListRow,
  ProductRow,
} from '../../shared/list-detail-management/model/list-detail-management-view.model';
import { BetterBuyDeclineEvent } from '@shared/models/better-buy-card.model';
import { Product } from '../../../shared/models/product.model';
import { EasyPricingUpdate } from '@usf/ngrx-pricing';

@Component({
  template: '',
})
export class GroupProductListBaseComponent {
  @Input() mode: UsfProductCardModeEnum;
  @Input() items: ListRow[];
  @Input() list: ListState;
  @Input() pricingDisabled: boolean;
  @Input() isOnline: boolean;
  @Input() showNotes = true;
  @Input() listItemNoteFeatureFlag: boolean;
  @Input() selectable = false;
  @Input() listViewMode: ListViewMode;
  @Input() selectedListType: ListType;
  @Input() screenWidth: number;
  @Input() selectedListItemKey: number | null;
  @Input() showLowLimit: boolean;

  @Output()
  ellipsisEmitter: EventEmitter<EllipsisClickData> = new EventEmitter();
  @Output() quantityUpdateEmitter: EventEmitter<any> = new EventEmitter();
  @Output()
  promotionClickEmitter: EventEmitter<any> = new EventEmitter();
  @Output()
  productCardClickEmitter: EventEmitter<ProductClickData> = new EventEmitter();
  @Output()
  itemNoteClickEmitter: EventEmitter<EllipsisClickData> = new EventEmitter();
  @Output()
  infoIconClickEmitter: EventEmitter<EllipsisClickData> = new EventEmitter();
  @Output()
  quantityInputEmitter: EventEmitter<IonInput> = new EventEmitter();
  @Output()
  collapseAlternatesEmitter: EventEmitter<ProductRow> = new EventEmitter();
  @Output()
  betterBuyDeclineEmitter: EventEmitter<BetterBuyDeclineEvent> =
    new EventEmitter();
  @Output() acceptSwapEmitter = new EventEmitter<Product>();
  @Output() selectProductCardEmitter = new EventEmitter<ProductSelectionData>();
  @Output() productConversionEmitter = new EventEmitter<Product>();
  @Output() priceChanged = new EventEmitter<EasyPricingUpdate>();
  @Output() PMEProductCardClickEmitter = new EventEmitter<ProductRow>();
  @Output() closeManualApproval = new EventEmitter<number>();

  readonly ItemTypes = ItemTypes;
  readonly ListTypes = ListTypes;
  readonly productCardModes = UsfProductCardModeEnum;
  readonly ListViewMode = ListViewMode;
  readonly ListType = ListType;

  constructor() {}

  trackItem(index: any, item: any) {
    return item ? index : undefined;
  }

  emitEllipsisEmitter(event: EllipsisClickData) {
    this.ellipsisEmitter.emit(event);
  }

  emitQuantityUpdateEmitter(event: any) {
    this.quantityUpdateEmitter.emit(event);
  }

  emitPromotionClickEmitter(event: any) {
    this.promotionClickEmitter.emit(event);
  }

  emitProductCardClickEmitter(event: ProductClickData) {
    this.productCardClickEmitter.emit(event);
  }

  emitItemNoteClickEmitter(event: EllipsisClickData) {
    this.itemNoteClickEmitter.emit(event);
  }

  emitInfoIconClickEmitter(event: EllipsisClickData) {
    this.infoIconClickEmitter.emit(event);
  }

  emitQuantityInputEmitter(event: IonInput) {
    this.quantityInputEmitter.emit(event);
  }

  emitCollapseAlternates(listRow: ListRow) {
    const productRow = listRow as ProductRow;
    this.collapseAlternatesEmitter.emit(productRow);
  }

  emitDeclineBetterBuy(betterBuyDeclineEvent: BetterBuyDeclineEvent) {
    this.betterBuyDeclineEmitter.emit(betterBuyDeclineEvent);
  }
  acceptSwap(product: Product) {
    this.acceptSwapEmitter.emit(product);
  }

  handleSelectionChange(event: any, item: any) {
    this.selectProductCardEmitter.emit({
      productNumber: item.productNumber,
      value: event,
      masterListItem: item.masterListItem,
    });
  }

  emitProductConversionEmitter(product: Product) {
    this.productConversionEmitter.emit(product);
  }

  emitPriceChanged(event: EasyPricingUpdate) {
    this.priceChanged.emit(event);
  }

  handlePmeProductClick(event: ProductRow) {
    this.PMEProductCardClickEmitter.emit(event);
  }

  handleCloseManualApproval(productNumber: number) {
    this.closeManualApproval.emit(productNumber);
  }
}
